import React from 'react';
import { observer } from 'mobx-react';
import { ImportPatientListTemplate } from 'themes/application/import/pages';
import { setCurrentView } from 'core/utils';
import { ImportPatientViewStore } from 'application/import/stores';

@setCurrentView((rootStore) => new ImportPatientViewStore(rootStore), 'listViewStore')
@observer
class ImportPatientList extends React.Component {
    render() {
        return <ImportPatientListTemplate {...this.props} />
    }
}

export default ImportPatientList;